import { render } from "./user-circle-icon.svg?vue&type=template&id=40a4b76e"
import script from "./user-circle-icon.svg?vue&type=script&lang=js"
export * from "./user-circle-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src279/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__